import { render, staticRenderFns } from "./ModelManagerDeleteConfirmationForm.vue?vue&type=template&id=1b5b9cce&"
import script from "./ModelManagerDeleteConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./ModelManagerDeleteConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports